import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig'; 

const MODULES = [
    { id: 'manage-events', label: 'Manage Events' },
    { id: 'manage-professionals', label: 'Manage Professionals' },
    { id: 'manage-campaigns', label: 'Manage Campaigns' },
    { id: 'manage-messages', label: 'Manage Messages' },
    { id: 'manage-subscribers', label: 'Manage Subscribers' },
    { id: 'manage-tasks', label: 'Task Board' },
    { id: 'manage-book-pages', label: 'Manage Book Pages (QR)' },
    { id: 'manage-landing-pages', label: 'Landing Page Builder' }, // YENİ EKLENEN MODÜL
    { id: 'manage-orders', label: 'Manage Orders' },
    { id: 'statistics', label: 'Statistics' }
];

const ROLES = ['editor', 'marketing', 'order', 'subscribedUser', 'normalUser'];

const RolePermissionsPage = () => {
    const [selectedRole, setSelectedRole] = useState('editor');
    const [permissions, setPermissions] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        const fetchPermissions = async () => {
            setLoading(true);
            try {
                const docRef = doc(db, 'rolePermissions', selectedRole);
                const docSnap = await getDoc(docRef);
                
                if (docSnap.exists()) {
                    setPermissions(docSnap.data().allowedModules || {});
                } else {
                    setPermissions({}); 
                }
            } catch (error) {
                console.error("Error fetching permissions:", error);
                setMessage({ type: 'danger', text: 'Failed to load permissions.' });
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [selectedRole]);

    const handleCheckboxChange = (moduleId) => {
        setPermissions((prev) => ({
            ...prev,
            [moduleId]: !prev[moduleId] 
        }));
    };

    const handleSave = async () => {
        setLoading(true);
        setMessage({ type: '', text: '' });
        try {
            const docRef = doc(db, 'rolePermissions', selectedRole);
            await setDoc(docRef, { allowedModules: permissions }, { merge: true });
            setMessage({ type: 'success', text: 'Permissions successfully updated!' });
        } catch (error) {
            console.error("Save error:", error);
            setMessage({ type: 'danger', text: 'An error occurred while saving permissions.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2 className="mb-4">Role Permissions Management</h2>
            <p className="text-muted">Define which pages each role can access across the system. The 'Admin' role has full access by default.</p>
            
            {message.text && (
                <div className={`alert alert-${message.type}`} role="alert">
                    {message.text}
                </div>
            )}

            <div className="card shadow-sm mb-4" style={{ maxWidth: '600px' }}>
                <div className="card-body">
                    <div className="mb-4">
                        <label htmlFor="roleSelect" className="form-label fw-bold">Select Role</label>
                        <select 
                            id="roleSelect" 
                            className="form-select" 
                            value={selectedRole} 
                            onChange={(e) => setSelectedRole(e.target.value)}
                        >
                            {ROLES.map(role => (
                                <option key={role} value={role}>{role}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-4">
                        <h5 className="mb-3">Accessible Pages / Modules</h5>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <div className="row">
                                {MODULES.map((mod) => (
                                    <div className="col-md-6 mb-2" key={mod.id}>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`check-${mod.id}`}
                                                checked={permissions[mod.id] || false}
                                                onChange={() => handleCheckboxChange(mod.id)}
                                            />
                                            <label className="form-check-label" htmlFor={`check-${mod.id}`}>
                                                {mod.label}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <button 
                        className="btn btn-primary w-100" 
                        onClick={handleSave} 
                        disabled={loading}
                    >
                        {loading ? 'Saving...' : 'Save Permissions'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RolePermissionsPage;